goog.module('yext.developerapps.wazeadssyncing.WazeConfiguration');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.developerapps.routes');
const Field = goog.require('yext.developerapps.wazeadssyncing.Field');

const WazeConfiguration = class
  extends Field {
  constructor() {
    super($('.js-wazeadssyncing-config-container'));
  }

  /** @override */
  doSubmit_(data) {
    return $.ajax({
      method: 'POST',
      url: routes.WazeAdsSyncing.save(),
      data: data,
    })
      .done(function(resp) {
        if (resp['success']) {
          window.location.href = routes.WazeAdsSyncing.view();
        } else {
          this.handleErrors_(resp['errors']);
        }
      }.bind(this));
  }
};

goog.exportSymbol('yext.developerapps.wazeadssyncing.WazeConfiguration',
  WazeConfiguration);

exports = WazeConfiguration;
